export const PLUS_MINUS_URI = '%C2%B1'
export const LESS_THAN_OR_EQUAL_URI = '%E2%89%A4'
